<styles-smart-table
  #smartTable
  [datasource]="projects.items"
  [showImageCell]="false"
  [expandable]="expandable"
  [mainColumns]="columnBuilder.getAllColumnNames()"
  [expandedColumns]="['details']"
  [showColumnHeaders]="showColumnHeaders"
  matSort
  (matSortChange)="updateSort($event)"
  [matSortActive]="$safeNavigationMigration(buildSort()?.active) ?? ''"
  [matSortDirection]="$safeNavigationMigration(buildSort()?.direction) ?? ''"
>
  <ng-container matColumnDef="type">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnBuilder.getAllColumnNames().length || 0">
      <div style="position: relative; top: 5px">{{$any(element)?.type }}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="image">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="image"></th>
    <td
      mat-cell
      *matCellDef="let element"
      [attr.rowspan]="smartTable.getImageRows(element)"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="image"
    >
      <framework-assets-image
        image
        [assetSet]="$safeNavigationMigration($any(element)?.defaultAsset)"
        [size]="130"
        [style.height.px]="smartTable.isExpanded(element) ? 124 : 44"
        [routerLink]="element | findRoute"
      >
      </framework-assets-image>
    </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="mid-column"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="date"
      mat-sort-header
    >
      Date
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      class="mid-column"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="date"
    >
      @if (element.status.id !== 'Completed') {
      <styles-icon-value-caption caption="Due date" icon="date_range">
        {{ $any(element)?.projectEndDate || $any(element)?.dueDate | date : 'mediumDate' }}
      </styles-icon-value-caption>
      } @else {
      <styles-icon-value-caption caption="Completion date" icon="date_range">
        {{ $any(element)?.projectEndDate || $any(element)?.dueDate | date : 'mediumDate' }}
      </styles-icon-value-caption>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="details">
    <td mat-cell *matCellDef="let element" [attr.colspan]="8">
      <div class="details-flex-wrapper">
        <framework-clusted-profile-images
          [userList]="$safeNavigationMigration($any(element)?.members)"
          [numberToShow]="10"
        >
        </framework-clusted-profile-images>

        @if ($any(element)?.module === 'InternalProject' || $any(element)?.module === 'AccountManagement') {
        <framework-access-level-chip [accessLevel]="{id:'Private', name:'Private'}" suffix="Project">
        </framework-access-level-chip>
        } @else {
        <framework-access-level-chip [accessLevel]="{id:'Public', name:'Public'}" suffix="Project">
        </framework-access-level-chip>
        } @for (tag of $any(element).tags; track tag) {
        <framework-tag-chip [tag]="tag"> </framework-tag-chip>
        } @if ($any(element)?.campaign) {
        <styles-icon-value-caption caption="Campaign" icon="campaign">
          {{ $any(element).campaign.name }}
        </styles-icon-value-caption>
        }

        <styles-icon-value-caption caption="Start Date" icon="date_range">
          {{ $any(element)?.projectStartDate | date : 'mediumDate' }}
        </styles-icon-value-caption>

        @if ($any(element)?.productInstance?.productDefinitionName) {
        <styles-icon-value-caption caption="Template" icon="backup_table">
          {{ $any(element).productInstance?.productDefinitionName }}
        </styles-icon-value-caption>
        } @if ($any(element)?.parent.type === 'StatementOfWork') {
        <styles-icon-value-caption caption="SOW" icon="receipt">
          {{ $any(element).parent.name }}
        </styles-icon-value-caption>
        } @if ($any(element)?.parent?.parent?.type === 'StatementOfWork') {
        <styles-icon-value-caption caption="SOW" icon="receipt">
          {{ $any(element).parent.parent.name }}
        </styles-icon-value-caption>
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="organization">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="mid-column"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="organization"
      mat-sort-header
    >
      Organization
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      class="mid-column"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="organization"
    >
      @if (element.feedDetails) {
      <styles-icon-value-caption caption="Organization" icon="corporate_fare">
        {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}
      </styles-icon-value-caption>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="default">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="default"
      mat-sort-header
    >
      Name
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="default">
      <a [routerLink]="element | findRoute">
        <div class="title ellipsis-text" [matTooltip]="$safeNavigationMigration($any(element)?.name)">
          @if (showOrgInTitle === true) {
          <span class="organization">
            {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}</span
          >&nbsp;&nbsp;&nbsp;<span class="carat">›</span>&nbsp;&nbsp; } @if (!(element | hasMaster) &&
          element?.parent?.module !== 'Contract' && $any(element)?.parent?.parent?.module !== 'Contract') {
          <span> {{ (element!.parent | findSpace)?.name }} › </span>
          } {{$any(element)?.name }}
        </div>

        @if ((element | workInType : 'MasterProject') && (element | masterSpaceTaskCount)) {
        <framework-master-project-progress-line [masterProject]="element" [rounding]="true" [stroke]="6" [gap]="3">
        </framework-master-project-progress-line>
        } @else {
        <framework-space-progress-line [space]="element" [rounding]="true" [stroke]="6">
        </framework-space-progress-line>
        }
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="status"
      mat-sort-header
    >
      Status
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="status">
      <framework-work-status-chip
        [workStatus]="$safeNavigationMigration($any(element)?.status)"
      ></framework-work-status-chip>
    </td>
  </ng-container>

  <ng-container matColumnDef="owner">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="owner" mat-sort-header>
      Owner
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="owner">
      <span class="owner-wrapper">
        <framework-person-image [person]="element.owner" size="33px"></framework-person-image>
        <span class="name">{{ element.owner.name }}</span>
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="contentType">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="contentType">
      Content Type
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="contentType">
      @if (($any(element)?.productType || ($any(element)?.productTypes && $any(element).productTypes!.length > 0))) {
      <styles-icon-value-caption
        caption="Content Type"
        icon="category"
        [matTooltip]="$safeNavigationMigration($any(element).productType?.name) + ' - ' + $safeNavigationMigration($any(element)?.productInstance?.variant)"
      >
        @if ($any(element)?.productTypes) { @for (type of $any(element)?.productTypes; track type; let isLast = $last) {
        {{ type.name }} @if (!isLast) { &nbsp;•&nbsp; } } } @else { {{ $any(element).productType.name }}@if
        ($any(element)?.productInstance?.variant) { &nbsp;•&nbsp;{{ $any(element)?.productInstance?.variant }} } }
      </styles-icon-value-caption>
      } @else { @if (element.productInstance) {
      <styles-icon-value-caption
        caption="Product Type"
        icon="category"
        [matTooltip]="$safeNavigationMigration($any(element)?.productInstance.name) + ' - ' + $safeNavigationMigration($any(element)?.productInstance?.variant)"
      >
        {{ $any(element)?.productInstance.name }}@if ($any(element)?.productInstance?.variant) { &nbsp;•&nbsp;{{
        $any(element)?.productInstance.variant }} }
      </styles-icon-value-caption>
      } }
    </td>
  </ng-container>

  <ng-container matColumnDef="units">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="units">Units</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="units">
      <div class="task-box">
        @if (element?.units?.totalUnits || 0 > 0) {
        <shared-unit-value-icon
          [element]="element"
          [isCore]="element.units?.currency && element.units.currency.id === 'CoreSmb'"
        >
          {{ element.units?.completedUnits ?? 0 | number : '1.0-2' }} / {{
          element.units?.totalUnits | number : '1.0-2' }}
        </shared-unit-value-icon>
        } @else { - }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="actions"></th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="actions">
      @if (element.defaultAction) {
      <framework-action-button [task]="element" [iconSize]="18"> </framework-action-button>
      } @if (($any(element)?.actions)!.length > 0) {
      <framework-listing-action-dropdown
        menu
        [level]="element.module === 'MasterProject' ? 'master' : 'project'"
        [location]="element | moduleTypePipe"
        [masterProject]="element | findMaster"
        [project]="element | findSpace"
        [phase]="element | phasePipe"
        [task]="element"
        [actions]="$safeNavigationMigration($any(element)?.actions)"
      >
      </framework-listing-action-dropdown>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="group-owner">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <framework-person-image [person]="group.group" size="30px"></framework-person-image>
        {{ group.group.name }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-date">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper"><mat-icon>calendar_today</mat-icon> {{group.group | date : 'MMMM y'}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-organization">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <mat-icon>corporate_fare</mat-icon>
        {{ group.group.organizationName || group.group.feedName}}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-status">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <framework-work-status-chip [workStatus]="group.group"></framework-work-status-chip>
      </div>
    </td>
  </ng-container>
</styles-smart-table>
